import { Reveal } from "@/components/pdp/reveal";
import { useProduct } from "@/components/pdp/PdpDataContext";

// PDP3.3-only copy of EditorialCollage. Decoupled from the shared
// EditorialCollage so PDP3.3 styling can evolve without touching PDP3.2.
export const EditorialCollageV33 = () => {
  const P = useProduct();
  const { collage } = P;
  const isV31 = !!P.v31;
  return (
    <section className="collage-v33 bg-riversol-blue text-white py-20 lg:py-32" data-testid="editorial-collage" data-inverted-bg="blue">
      <div className="max-w-[1600px] mx-auto px-4 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8 items-stretch">
          {/* Copy in negative space */}
          <div className="flex flex-col justify-center lg:pr-10 order-1">
            <div className="pdp-eyebrow font-mono text-[11px] tracking-[0.24em] uppercase text-white/60 mb-6">
              {collage.eyebrow}
            </div>
            <h2
              className={
                isV31
                  ? "font-mono text-3xl md:text-4xl lg:text-5xl mb-8 tracking-tight leading-[1.05]"
                  : "text-3xl md:text-4xl leading-[1.08] tracking-tight font-light mb-6"
              }
            >
              {collage.headline}
            </h2>
            <p
              className={
                isV31
                  ? "text-[16px] lg:text-[17px] leading-[1.75] lg:leading-[1.8] text-white/70"
                  : "text-sm leading-relaxed text-white/70"
              }
            >
              {collage.body}
            </p>
          </div>

          {/* Smaller floating bottle, vertically centered against the banners */}
          <div className="order-2 relative aspect-square lg:aspect-auto lg:min-h-0" data-testid="collage-center-image">
            <img
              src={collage.centerImage}
              alt={collage.centerAlt}
              className="w-full h-full object-cover lg:absolute lg:inset-0 lg:p-4"
              style={{ objectPosition: "28% 50%" }}
            />
          </div>

          {/* Two landscape 16/9 banners */}
          <div className="order-3 flex flex-col gap-6 lg:gap-8">
            <Reveal>
              <div className="editorial-frame aspect-[16/9] w-full group" style={{ clipPath: "inset(0 round 20px)" }}>
                <img src={collage.topImage} alt={collage.topAlt} className="w-full h-full object-cover img-zoom" />
              </div>
            </Reveal>
            <Reveal delay={0.12}>
              <div className="editorial-frame aspect-[16/9] w-full group" style={{ clipPath: "inset(0 round 20px)" }}>
                <img src={collage.leftImage} alt={collage.leftAlt} className="w-full h-full object-cover img-zoom" />
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EditorialCollageV33;
